import axios from "axios";
import apis from '../index';

export const getCountryApi = async () => {
    const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
    try {
        const response = await axios.get(
            apis.countryStateCity.country,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return response;
    } catch (error) {
        console.error("Error creating facility:", error);
        throw error;
    }
};

export const getStateApi = async (id) => {
    const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
    try {
        const response = await axios.get(
            `${apis.countryStateCity.state}/${id}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return response;
    } catch (error) {
        console.error("Error creating facility:", error);
        throw error;
    }
};


export const getCityApi = async (country_id, state_id) => {
    const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
    try {
        const response = await axios.get(
            `${apis.countryStateCity.city}/${country_id}/${state_id}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return response;
    } catch (error) {
        console.error("Error creating facility:", error);
        throw error;
    }
};
